var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-second-panel"},[_vm._t("default"),_c('div',{staticClass:"r-second-panel__close"},[_c('r-button',{attrs:{"icon":"close-delete","simple":"","mini":""},on:{"click":_vm.close}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }